import type { CSSProperties } from 'react';
import DismissIconSvg from '../../assets/icons/dismiss.svg?react';

export interface IconProps {
    size?: number | string;
    className?: string;
    style?: CSSProperties;
    onClick?: () => void;
}

const DismissIcon: React.FC<IconProps> = ({ size = 16, className = '', style = {}, onClick }) => {
    const iconStyle: CSSProperties = {
        width: typeof size === 'number' ? `${size}px` : size,
        height: typeof size === 'number' ? `${size}px` : size,
        display: 'inline-block',
        ...style,
    };

    return <DismissIconSvg className={className} style={iconStyle} onClick={onClick} />;
};

export default DismissIcon;
